import { Validator } from '@vista-digital/validator';
import { googleRecaptchaV2ConfigValidator } from '../subcomponents/google-recaptcha-v2/types/config';
export const captchaConfigValidator = Validator.any([googleRecaptchaV2ConfigValidator]);
//# sourceMappingURL=config.js.map